import React from 'react';
import Styles from './styles.module.css';
import { AiOutlineLoading3Quarters } from "react-icons/ai";

// 表などのデータを最初に読み込んでいるあいだの表示。
// 読み込み前に「該当する〜がありません」が出て、0件と勘違いされないようにする。
const Loading: React.FC<{ text?: string }> = ({ text = "読み込み中です。しばらくお待ちください。" }) => (
  <div className={Styles.loading} role="status" data-testid="school-loading">
    <AiOutlineLoading3Quarters className={Styles.icon} />
    <p>{text}</p>
  </div>
);

export default Loading;
